import {useState} from 'react'
import { useNavigate } from "react-router-dom"
import logo from "../../assets/images/logo.png"
import API_URL from "../../apiConfig"

function FormLogin() {

  const [identifiant, setIdentifiant] = useState("")
  const [mdp, setMdp] = useState("")
  const [error, setError] = useState("")
  const [showPassword, setShowPassword] = useState(false)

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
      e.preventDefault();
      setIdentifiant("")
      setMdp("")

      const dataToSend = {
        identifiant: identifiant.trim().replace(/['";]/g, ""),
        mdp: mdp.trim().replace(/['";]/g, "")
      };

    try {
        const res = await fetch(`${API_URL}/admin/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(dataToSend)
        });

        const data = await res.json()

        if (res.ok || data.success) {
          // Redirige vers le dashboard
          navigate("admin-connected");
        } else {
          setError(data.message || "Identifiants invalides");
        }
      } catch (err) {
        console.error(err);
        setError("Erreur serveur, réessaye plus tard");
      }
  };


  return (
    <div className="w-100 min-vh-100 bg-lamp-gradient d-flex align-items-center justify-content-center p-3">
        <div className="card-custom d-flex flex-column animate__animated animate__fadeIn" style={{ maxWidth: '450px', width: '100%', backgroundColor: '#ffffff' }}>
            {/* Header bleu pour la division */}
            <div className="bg-lamp p-4 text-center">
                <img src={logo} alt="logo" width="70" className="rounded-circle mb-2 border border-2 border-white shadow-sm" />
                <h1 className="text-white h5 fw-bold mb-0 outfit tracking-wide">ADMINISTRATION</h1>
            </div>
            
            <div className="p-4 p-md-5">
                <form onSubmit={handleSubmit}>
                    <h2 className="mb-4 text-dark h4 fw-bold">S'authentifier</h2>
                    <p>Saisissez vos identifiants pour accéder à votre espace administratif.</p>

                    {error && (
                        <div className="alert alert-danger py-2 small mb-4 text-center" style={{ borderRadius: '8px' }}>
                            <i className="bi bi-exclamation-circle-fill me-2"></i> {error}
                        </div>
                    )}

                    <div className="mb-3">
                        <label className="text-secondary small mb-1 fw-bold">IDENTIFIANT</label>
                        <input 
                            className="form-control-custom" 
                            type="text" 
                            id="ident" 
                            name="identifiant" 
                            placeholder="Entrez votre identifiant" 
                            onChange={e => setIdentifiant(e.target.value)} 
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label className="text-secondary small mb-1 fw-bold">MOT DE PASSE</label>
                        <div className="position-relative">
                            <input 
                                className="form-control-custom w-100" 
                                type={showPassword ? "text" : "password"} 
                                id="motpasse" 
                                name="mdp" 
                                placeholder="••••••••" 
                                onChange={e => setMdp(e.target.value)}
                                required
                                style={{ paddingRight: '45px' }}
                            />
                            <button 
                                type="button"
                                className="position-absolute end-0 top-50 translate-middle-y border-0 bg-transparent pe-3 text-muted"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ zIndex: 10, cursor: 'pointer' }}
                            >
                                <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                            </button>
                        </div>
                    </div>

                    <button className="btn-primary-custom w-100" type="submit" style={{ height: '52px' }}>
                        SE CONNECTER
                    </button>
                    
                    <div className="mt-4 text-center pt-3 border-top">
                        <p className="text-muted extra-small mb-0">
                            LAMP Edification &copy; {new Date().getFullYear()}
                        </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
  );
}


export default FormLogin;